import type { UniverseId } from './universes';

export const HERO_IMAGES: Record<UniverseId, { src: string; alt: string; caption: string }> = {
  rise: {
    src: '/assets/universes/rise-hero-v2.webp',
    alt: 'Une entrepreneuse présente son catalogue en ligne depuis sa boutique.',
    caption: 'Votre offre. Une expérience qui donne envie.',
  },
  'r-node': {
    src: '/assets/universes/r-node-hero-v2.webp',
    alt: 'Une dirigeante coordonne les opérations de son entreprise depuis sa tablette.',
    caption: 'Votre organisation. Votre plateforme.',
  },
  'sx-business': {
    src: '/assets/universes/sx-business-hero-v2.webp',
    alt: 'Une dirigeante et son conseiller construisent les prochaines étapes de son développement.',
    caption: 'Un cap partagé. Des décisions concrètes.',
  },
  elina: {
    src: '/assets/universes/elina-hero-v2.webp',
    alt: 'Elina, une présence humaine en veste turquoise, avec de fins circuits discrets sur le visage.',
    caption: 'Cinq compétences. À vos côtés.',
  },
};

